import gql from 'graphql-tag'

export default gql`
  mutation SaveVZF($input: VZFDataInput!) {
    saveVZF(input: $input)
  }
`
